// Cull view (§10): full-screen single photo; 0–5 rate, X rejects, ←/→ move, auto-advance after a
// rating or reject (toggle). Ratings are shown as numbers too, never by colour alone.
import { useLibrary } from '../../state/library';
import { useT } from '../../i18n';

export function CullOverlay() {
  const t = useT();
  const photo = useLibrary((s) => s.photos.find((p) => p.id === s.activeId) ?? null);
  const autoAdvance = useLibrary((s) => s.autoAdvance);
  if (!photo) return null;
  return (
    <div
      data-testid="cull-overlay"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        padding: '8px 12px',
        background: 'rgba(0,0,0,0.55)',
        zIndex: 5,
      }}
    >
      <strong style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {photo.name}
      </strong>
      <span aria-label={t('rating')} data-testid="cull-rating" style={{ color: '#ffd84d' }}>
        {'★'.repeat(photo.rating)}
        {'☆'.repeat(5 - photo.rating)} {photo.rating}
      </span>
      {photo.rejected && <span style={{ color: '#ff6b6b', fontWeight: 700 }}>✕ {t('rejected')}</span>}
      <span style={{ flex: 1 }} />
      <label style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={autoAdvance}
          onChange={(e) => useLibrary.getState().set({ autoAdvance: e.target.checked })}
        />
        {t('autoAdvance')}
      </label>
      <button onClick={() => useLibrary.getState().set({ cull: false })}>{t('exitCull')} (Esc)</button>
    </div>
  );
}
